import {toast} from '@kroll-resolver-crisp/ui-components-react';

export type ToastType = 'success' | 'info' | 'warning' | 'error';

/**
 Raises a toast on the package `Toaster` that `AppShell` mounts. The Toaster owns the timer, the
 stacking and the close button, and announces `error` and `warning` urgently.
 */
export function showToast(title: string, type: ToastType = 'success'): void {
  toast.add({title, type});
}
